module.exports = __webpack_public_path__ + "img/contact.2043da45.jpg";